import { Component, OnInit } from '@angular/core'
import { PrintService } from 'src/app/_shared/services/print.service'
import { PurchaseService } from '../../views/agrishop/services/purchase.service'

@Component({
  selector: 'app-purchase-order-receipt',
  templateUrl: './purchase-order-receipt.component.html',
  styleUrls: ['./purchase-order-receipt.component.scss'],
})
export class PurchaseOrderReceiptComponent implements OnInit {
  date = new Date()
  constructor(
    private purchaseService: PurchaseService,
    public printService: PrintService
  ) {}

  ngOnInit() {
    this.printService.onDataReady()
  }

  public get purchaseOrder() {
    return this.purchaseService.currentPurchaseOrder
  }

  public get items() {
    if (this.purchaseOrder && this.purchaseOrder.items) {
      return this.purchaseOrder.items
    }
    return []
  }

  public get totalCost() {
    if (this.purchaseOrder) {
      return this.purchaseOrder.items.reduce(
        (acc, cur) => acc + cur.qty * cur.unitPrice,
        0
      )
    }
    return 0
  }
}
